<script>
export default {
  props: ['stableData'],
  data () {
    return {
      posSelectOptions: [{
        value: 1,
        label: 'Ua'
      }, {
        value: 2,
        label: 'Ub'
      }, {
        value: 3,
        label: 'Uc'
      }, {
        value: 4,
        label: 'Ia'
      }, {
        value: 5,
        label: 'Ib'
      }, {
        value: 6,
        label: 'Ic'
      }, {
        value: 7,
        label: 'In'
      }],
      posSelectValue: 1,
      showFft: [],
      tableData: {},
      thdCommandInterval: null
    }
  },
  watch: {
    posSelectValue () {
      this.setValue()
    },
    freqSelectValue () {
      this.updateData()
    }
  },
  computed: {
    freqSelectValue () {
      return this.$store.state.freqSelectValue
    }
  },
  mounted () {
    this.updateData()
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.$api.getTs({
          collection: '',
          sn: this.$store.state.sn
        }).then((res) => {
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg)
            return
          }
          if (this.lastTs !== res.data.data.ts) {
            this.lastTs = res.data.data.ts
            this.updateData()
          }
        })
      }, 1000)
    }
    this.pollCommand()
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    this.pollStop()
  },
  methods: {
    pollCommand () {
      if (this.$store.state.reqMode === 'udp' || this.$store.state.highSpdMode) {
        this.sendCommand()
        if (!this.thdCommandInterval) {
          this.thdCommandInterval = setInterval(() => {
            this.sendCommand()
          }, 600000)
        }
      } else {
        this.pollStop()
      }
    },
    pollStop () {
      if (this.thdCommandInterval) {
        clearInterval(this.thdCommandInterval)
        this.thdCommandInterval = null
      }
    },
    sendCommand () {
      this.$api.command({
        sn: this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        lists: [[1, 6, 1]]
      }).then(res => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
        }
      })
    },
    async updateData () {
      const params = {
        'collection': 'meter_inter_data',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'fields': ['InterUa', 'InterUb', 'InterUc', 'InterIa', 'InterIb', 'InterIc', 'InterIn']
      }
      const {data: res} = await this.$api.queryLastData(params)
      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      // console.log(res.data)
      this.tableData = res.data
      this.setValue()
    },

    setValue () {
      var page = this.posSelectValue
      var data = this.tableData
      if (page === 1) {
        this.showFft = data ? data.inter_ua : []
      } else if (page === 2) {
        this.showFft = data ? data.inter_ub : []
      } else if (page === 3) {
        this.showFft = data ? data.inter_uc : []
      } else if (page === 4) {
        this.showFft = data ? data.inter_ia : []
      } else if (page === 5) {
        this.showFft = data ? data.inter_ib : []
      } else if (page === 6) {
        this.showFft = data ? data.inter_ic : []
      } else if (page === 7) {
        this.showFft = data ? data.inter_in : []
      }
    }
  }
}
</script>

<template>
  <div class="pg" style="margin-top: 70px">
    <div class="dataItems">
      <div class="title">间谐波频谱表</div>

      <div style="display: flex; flex-wrap: wrap; height: 35px; line-height: 35px; margin-bottom: 10px">
        <div style="display: flex; width: 100%;">
          <div
            style="display: flex; align-items: center; margin-left: 20px">
            <div style="width: 80px; text-align: left">电气量</div>
            <div style="width: 150px; margin-left: 10px">
              <el-select v-model="posSelectValue" placeholder="请选择" size="20px">
                <el-option
                  v-for="item in posSelectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div style="height: calc(100% - 100px);">
        <div class="dataItem" style="height: 100%; border-top: 1px solid black">
          <div class="dataName">
            <div class="dataTitle">频率(Hz)</div>
            <div class="dataNvItem">{{ 5 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 10 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 15 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 20 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 25 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 30 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 35 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 40 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 45 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 50 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 55 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 60 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 65 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 70 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 75 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 80 + (freqSelectValue - 1) * 400 }}</div>
          </div>
          <div class="dataValue" style="border-right: 1px solid black">
            <div class="dataTitle">百分比</div>
            <div class="dataNvItem">{{ Number(showFft[(freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[1 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[2 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[3 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[4 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[5 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[6 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[7 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[8 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[9 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[10 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[11 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[12 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[13 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[14 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[15 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
          </div>
          <div class="dataName">
            <div class="dataTitle">频率(Hz)</div>
            <div class="dataNvItem">{{ 85 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 90 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 95 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 100 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 105 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 110 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 115 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 120 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 125 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 130 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 135 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 140 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 145 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 150 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 155 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 160 + (freqSelectValue - 1) * 400 }}</div>
          </div>
          <div class="dataValue" style="border-right: 1px solid black">
            <div class="dataTitle">百分比</div>
            <div class="dataNvItem">{{ Number(showFft[16 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[17 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[18 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[19 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[20 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[21 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[22 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[23 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[24 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[25 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[26 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[27 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[28 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[29 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[30 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[31 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
          </div>
          <div class="dataName">
            <div class="dataTitle">频率(Hz)</div>
            <div class="dataNvItem">{{ 165 + (freqSelectValue - 1) * 80 }}</div>
            <div class="dataNvItem">{{ 170 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 175 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 180 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 185 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 190 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 195 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 200 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 205 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 210 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 215 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 220 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 225 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 230 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 235 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 240 + (freqSelectValue - 1) * 400 }}</div>
          </div>
          <div class="dataValue" style="border-right: 1px solid black">
            <div class="dataTitle">百分比</div>
            <div class="dataNvItem">{{ Number(showFft[32 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[33 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[34 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[35 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[36 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[37 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[38 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[39 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[40 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[41 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[42 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[43 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[44 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[45 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[46 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[47 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
          </div>
          <div class="dataName">
            <div class="dataTitle">频率(Hz)</div>
            <div class="dataNvItem">{{ 245 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 250 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 255 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 260 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 265 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 270 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 275 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 280 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 285 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 290 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 295 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 300 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 305 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 310 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 315 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 320 + (freqSelectValue - 1) * 400 }}</div>
          </div>
          <div class="dataValue" style="border-right: 1px solid black">
            <div class="dataTitle">百分比</div>
            <div class="dataNvItem">{{ Number(showFft[48 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[49 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[50 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[51 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[52 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[53 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[54 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[55 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[56 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[57 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[58 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[59 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[60 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[61 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[62 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[63 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
          </div>
          <div class="dataName">
            <div class="dataTitle">频率(Hz)</div>
            <div class="dataNvItem">{{ 325 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 330 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 335 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 340 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 345 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 350 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 355 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 360 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 365 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 370 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 375 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 380 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 385 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 390 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 395 + (freqSelectValue - 1) * 400 }}</div>
            <div class="dataNvItem">{{ 400 + (freqSelectValue - 1) * 400 }}</div>
          </div>
          <div class="dataValue">
            <div class="dataTitle">百分比</div>
            <div class="dataNvItem">{{ Number(showFft[64 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[65 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[66 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[67 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[68 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[69 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[70 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[71 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[72 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[73 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[74 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[75 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[76 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[77 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[78 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
            <div class="dataNvItem">{{ Number(showFft[79 + (freqSelectValue - 1) * 80]).toFixed(1) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";
.pg{
  width: 54%;
  height: calc(65vh - 50px);
}

.dataName {
  width: 10%;
}

.dataValue {
  width: 10%;
//border-right: 1px solid black;
}

.dataTitle {
  height: 30px;
}

.dataNvItem {
  height: calc((100% - 50px) / 16);
}

</style>



// WEBPACK FOOTER //
// src/pages/Stable/ThdTable/ThdTableRange.vue